const en_whs_itemmove = {
    "": "perpindahan barang",
    detail: "item transfer detail",
}

export default en_whs_itemmove;